import React from 'react';

import leftImg from '../../../assets/images/bg-img.png';
import {
	AuthBase,
	AuthBaseFactory,
	AuthBaseProps,
} from '../../../../../libs/IdeLink.Web.Common/src/modules/Auth/Pages/components/AuthBase/AuthBase';

const OxylinkAuthBase = (props: AuthBaseProps) => <AuthBase {...props} leftImg={leftImg} />;
export const overrideOxylinkAuthBase = () => AuthBaseFactory.register('**', OxylinkAuthBase);
